document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.header__submenu-accordion summary').forEach(function(summary) {
    summary.addEventListener('click', function() {
      var current = this.parentElement;
      document.querySelectorAll('.header__submenu-accordion').forEach(function(accordion) {
        if (accordion !== current) {
          accordion.removeAttribute('open');
        }
      });
    });
  });
});